type Edges = {readonly edges?: ReadonlyArray<{readonly node?: unknown} | null> | null} | null | undefined;

/**
 * Whether the project's Baseline has any time or expense line at all. The Baseline page counts only lines under one
 * of the project's deliverables as content on a deliverables project, but the insert refuses a Baseline with any line.
 */
export const hasAnyBaselineLine = (project: {
	readonly phaseBaselineRoles?: Edges;
	readonly phaseBaselineExpenses?: Edges;
}): boolean =>
	[...(project.phaseBaselineRoles?.edges ?? []), ...(project.phaseBaselineExpenses?.edges ?? [])].some(edge => !!edge?.node);

type EntryPointState = {
	flagOn: boolean;
	/** The Baseline has any time or expense line, under a deliverable or not: the insert needs an empty Baseline. */
	hasBaselineLines: boolean;
	shouldBlockBaseline: boolean;
	baselineLocked: boolean;
	canCreatePhase: boolean;
	/** The project already has phases (or deliverables, where it uses them), so the insert replaces them. */
	hasContent: boolean;
	canDeletePhase: boolean;
};

/**
 * The Insert Baseline Template button shows only while the Baseline builder stepper does, and only
 * when the user may do the insert: creating phases always, and deleting them too when the insert
 * would replace existing content.
 */
export const canShowInsertBaselineTemplate = (state: EntryPointState): boolean =>
	state.flagOn &&
	!state.hasBaselineLines &&
	!state.shouldBlockBaseline &&
	!state.baselineLocked &&
	state.canCreatePhase &&
	(!state.hasContent || state.canDeletePhase);
